import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useContainer } from '@thom/folio-ui/app/container'
import { AppShell } from '@thom/folio-ui/components/app-shell'
import { SignedIn } from '@thom/folio-ui/components/signed-in'

const AuthenticatedLayout = () => {
	const { lastProject } = useContainer()

	useEffect(() => lastProject.settle(), [lastProject])

	return (
		<SignedIn>
			<AppShell>
				<Outlet />
			</AppShell>
		</SignedIn>
	)
}

export const Route = createFileRoute('/_authenticated')({
	component: AuthenticatedLayout,
})
